import React from 'react'
import { Route, Switch } from 'react-router-dom'
import * as routesNames from '../../../constants/routes'
import AppLayout from '../../../config/default/default'
import NotFound from '../NotFound'
import RecoveryDashboard from '../Recovery/Dashboard/recoveryDashboard.js'
export default function RecoveryRoutes() {
  return (
    <AppLayout>
        <Switch>
            <Route exact path={routesNames.RECOVERYDASHBOARD} component={RecoveryDashboard} />
            <Route component={NotFound} />
        </Switch>
    </AppLayout>
  )
}
